import { render } from "./cameraDetector.vue?vue&type=template&id=65a33a8a&scoped=true"
import script from "./cameraDetector.vue?vue&type=script&lang=js"
export * from "./cameraDetector.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=65a33a8a&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a33a8a"]])

export default __exports__